var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 20.9746C2.76472 20.9746 0.75 18.9599 0.75 16.4746V15.3496C0.75 14.7283 1.2675 14.243 1.85463 14.0397C3.1761 13.5822 4.125 12.3267 4.125 10.8496C4.125 9.37251 3.1761 8.11704 1.85463 7.65953C1.2675 7.45625 0.75 6.97093 0.75 6.34961V5.22461C0.75 2.73933 2.76472 0.724609 5.25 0.724609H9.75H18.75C21.2353 0.724609 23.25 2.73933 23.25 5.22461V6.34961C23.25 6.97093 22.7325 7.45625 22.1454 7.65953C20.8239 8.11704 19.875 9.37251 19.875 10.8496C19.875 12.3267 20.8239 13.5822 22.1454 14.0397C22.7325 14.243 23.25 14.7283 23.25 15.3496V16.4746C23.25 18.9599 21.2353 20.9746 18.75 20.9746H9.75H5.25ZM10.5938 4.09961C10.5938 3.63362 10.216 3.25586 9.75 3.25586C9.28401 3.25586 8.90625 3.63362 8.90625 4.09961V6.34961C8.90625 6.8156 9.28401 7.19336 9.75 7.19336C10.216 7.19336 10.5938 6.8156 10.5938 6.34961V4.09961ZM9.75 14.5059C10.216 14.5059 10.5938 14.8836 10.5938 15.3496V17.5996C10.5938 18.0656 10.216 18.4434 9.75 18.4434C9.28401 18.4434 8.90625 18.0656 8.90625 17.5996V15.3496C8.90625 14.8836 9.28401 14.5059 9.75 14.5059ZM10.5938 9.72461C10.5938 9.25862 10.216 8.88086 9.75 8.88086C9.28401 8.88086 8.90625 9.25862 8.90625 9.72461V11.9746C8.90625 12.4406 9.28401 12.8184 9.75 12.8184C10.216 12.8184 10.5938 12.4406 10.5938 11.9746V9.72461Z",
    fill: "#407BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.3754cc59b7ba23078488247529bac669.svg";
export { ForwardRef as ReactComponent };